import authProvider from "./authProvider.js";
import dataProvider from "./dataProvider.js";
import i18nProvider from "./i18nProvider.js";

export default { authProvider, dataProvider, i18nProvider };
